import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Flexbox, FlexboxCenter } from '../../Layout';
import { TextDefault } from '../../Text';
import { Icon } from '../../Icon';
import { Colors } from '../../../../styles/colors';

const HoverEffect = css`
  cursor: pointer;
  transition: color 150ms ease-out;
  
  &:hover {
    @media (pointer: fine) {
      color: ${Colors.tertiary};
    }
  }
`;

const EditItemWrapper = styled(Flexbox)`
  flex: 1;

  ${HoverEffect}
  
  ${TextDefault} {
    flex: 1;
    padding: .5rem 1rem;
  }
`;

const DeleteIconWrapper = styled(FlexboxCenter)`
  margin-left: 1rem;
  flex-shrink: 0;
  
  ${HoverEffect}
`;

const NoteItemWrapper = styled(Flexbox)`
  //
`;

interface Props {
  title: string;
  onEditClick: () => void;
  onDeleteClick?: () => void;
}
export const NoteItem: FC<Props> = ({ onEditClick, onDeleteClick, title, ...props }) => {
  return (
    <NoteItemWrapper>
      <EditItemWrapper onClick={onEditClick}>
        <FlexboxCenter>
          <Icon icon={'edit'} size={20} />
        </FlexboxCenter>
        <TextDefault>{ title }</TextDefault>
      </EditItemWrapper>
      {
        onDeleteClick &&
        <DeleteIconWrapper onClick={onDeleteClick}>
          <Icon icon={'trash'} size={20} />
        </DeleteIconWrapper>
      }
    </NoteItemWrapper>
  )
}
